export default __webpack_public_path__ + "static/media/Degrees3_Cp_background.37ce4e36.png";